import http from '@/utils/http'
import { PATH_PAYMENT } from './consts'
import {
  GrantReq,
  OrderAddReq,
  OrderPayReq,
  BackReq,
  CouponListReq,
  OrderListReq,
} from './types/payment'

// 获取小程序弹框有无优惠券领取
export const couponCheck = () => {
  return http.post(`${PATH_PAYMENT}/coupon/v1/check`)
}

// 下发优惠券到指定账户（用户点击领取调用）
export const couponGrant = (data: GrantReq) => {
  return http.post(`${PATH_PAYMENT}/coupon/v1/grant`, data)
}

// 获取优惠券列表
export const couponList = (data: CouponListReq = { page: 1, size: 10 }) => {
  return http.post(`${PATH_PAYMENT}/coupon/v1/list`, data)
}

// 获取优惠券列表
export const orderList = (data: OrderListReq) => {
  return http.post(`${PATH_PAYMENT}/order/v1/orderList`, data)
}

// 创建订单（用户点击去交费时调用）
export const orderAdd = (data: OrderAddReq) => {
  return http.post(`${PATH_PAYMENT}/order/v1/add`, data)
}

// 支付（用户支付页面点击支付调用，支付完成将返回预付单信息，该操作会请求微信服务生成预付单）
export const orderPay = (data: OrderPayReq) => {
  return http.post(`${PATH_PAYMENT}/order/v1/pay`, data)
}

// 获取微信支付签名
export const orderPaySign = (orderCode: string) => {
  return http.post(`${PATH_PAYMENT}/order/v1/paysign`, { orderCode })
}

// 查看订单详情（用户未缴费页面展示、订单列表--订单详情中使用）
export const orderDetail = (orderCode: string) => {
  return http.post(`${PATH_PAYMENT}/order/v1/detail`, { orderCode })
}

// 查看订单详情（用户未缴费页面展示、订单列表--订单详情中使用）
export const orderCourseDetail = (orderCode: string) => {
  return http.post(`${PATH_PAYMENT}/order/v1/course/detail`, { orderCode })
}

// 取消订单
export const orderCancel = (orderCode: string) => {
  return http.post(`${PATH_PAYMENT}/order/v1/cancel`, { orderCode })
}

// 退款
export const orderBack = (data: BackReq) => {
  return http.post(`${PATH_PAYMENT}/order/v1/back`, data)
}
